module.exports = __webpack_public_path__ + "img/proactive-transport.082bc154.png";